import { render, staticRenderFns } from "./FilesActive.vue?vue&type=template&id=227a552f"
import script from "./FilesActive.vue?vue&type=script&lang=js"
export * from "./FilesActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports